import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局样式
import '../src/assets/css/reset.css'
import '../src/assets/css/global.css'

//element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


//表格
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 请求
import axios from 'axios';
Vue.prototype.axios = axios

// 图形验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

//byk方法
import bykApi from './common/bykApi.js'
Vue.prototype.bykApi = bykApi

//二维码
import QRCode from "qrcodejs2";
Vue.prototype.QRCode = QRCode

Vue.config.productionTip = false

//线上环境去掉console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function() {};
  }
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js